(() => {
  if (window.bramblejoyCheckoutFeedback) return;
  window.bramblejoyCheckoutFeedback = true;

  const selector = 'button[data-bj-checkout][name="checkout"]';
  let pending = null;

  function reset(retry = false) {
    if (!pending) return;
    const { button, label, text, status, timer, ariaDisabled, ariaBusy } = pending;
    clearTimeout(timer);
    label.textContent = text;
    delete button.dataset.bjCheckoutPending;
    if (ariaDisabled === null) button.removeAttribute('aria-disabled');
    else button.setAttribute('aria-disabled', ariaDisabled);
    if (ariaBusy === null) button.removeAttribute('aria-busy');
    else button.setAttribute('aria-busy', ariaBusy);
    if (status) {
      status.textContent = retry ? button.dataset.retryText : '';
      status.classList.toggle('visually-hidden', !retry);
    }
    pending = null;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(selector);
    if (button && pending) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const button = event.submitter;
    if (!button?.matches(selector) || event.defaultPrevented || button.disabled) return;
    if (pending) {
      event.preventDefault();
      return;
    }

    const label = button.querySelector('[data-bj-checkout-label]');
    if (!label || !button.dataset.loadingText) return;
    const status = document.getElementById(button.dataset.bjCheckoutStatus);
    pending = {
      button,
      label,
      text: label.textContent,
      status,
      ariaDisabled: button.getAttribute('aria-disabled'),
      ariaBusy: button.getAttribute('aria-busy'),
      timer: setTimeout(() => reset(true), 20000),
    };
    label.textContent = button.dataset.loadingText;
    button.dataset.bjCheckoutPending = 'true';
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.classList.add('visually-hidden');
      status.textContent = button.dataset.loadingText;
    }
    queueMicrotask(() => {
      if (event.defaultPrevented) reset();
    });
  });

  window.addEventListener('pageshow', () => reset());

  const walletTemplateSelector = 'template[data-bj-shop-pay-only]';

  function renderShopPay(root) {
    const templates = root.matches?.(walletTemplateSelector)
      ? [root]
      : root.querySelectorAll(walletTemplateSelector);
    templates.forEach((template) => {
      try {
        const checkout = template.content.querySelector('shopify-accelerated-checkout-cart');
        const wallets = JSON.parse(checkout?.getAttribute('wallet-configs') || '[]');
        const shopPay = wallets.filter((wallet) => wallet.name === 'shop_pay');
        if (!checkout || !shopPay.length) {
          template.remove();
          return;
        }
        checkout.setAttribute('wallet-configs', JSON.stringify(shopPay));
        checkout.replaceChildren();
        template.replaceWith(template.content);
      } catch {
        template.remove();
      }
    });
  }

  renderShopPay(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) renderShopPay(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();
